<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <el-row>
      <el-form size="medium" :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" style="padding-top:0;margin-top:0"
        label-suffix="：">
        <el-form-item label="产品名称">
          <el-input v-model="searchForm.PRODUCT_NAME"></el-input>
        </el-form-item>
        <el-form-item label="产品编码">
          <el-input v-model="searchForm.PRODUCT_CODE"></el-input>
        </el-form-item>
        <el-form-item label="供应商">
          <el-select v-model="searchForm.SUPPLIER_ID" filterable placeholder="请选择" clearable>
            <el-option v-for="item in 供应商列表" :key="item.value" :label="item.SUPPLIER_NAME" :value="item.SUPPLIER_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点">
          <el-select filterable v-model="searchForm.PROJECT_ID" placeholder="请选择" clearable>
            <el-option v-for="item in 项目点列表" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker v-model="searchForm.DATE_RANGE" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="筛选()">筛选</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row style="margin-top: 24px">
      <el-table :data="列表数据" border stripe style="width: 100%">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="ID" label="订单ID">
          <template slot-scope="scope">
            <el-button type="text" @click="点击订单编号(scope.row)" style="text-decoration: underline;">{{scope.row.ID}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="SEND_DAY" label="送货日期" min-width="100"></el-table-column>
        <el-table-column prop="VENDOR_NAME" label="供应商" min-width="200"></el-table-column>
        <el-table-column prop="PROJECT_NAME" label="项目点" min-width="100"></el-table-column>
        <el-table-column prop="DK_NAME" label="档口" min-width="100"></el-table-column>
        <el-table-column prop="REAL_PURCHASE_FEE" label="采购验收总金额" align="right" min-width="150"></el-table-column>
        <el-table-column prop="REAL_SALE_FEE" label="销售验收总金额" align="right" min-width="150"></el-table-column>
        <el-table-column prop="STATUS" label="订单状态" min-width="150"></el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  haveDSXMDFun,
} from 'api/sellOrder';

import { haveSupplierFun, 订单查询 } from 'api/DSOrder';
import date, { 判断日期范围是否超过限制 } from '@/assets/common/date';

export default {
  data() {
    return {
      列表数据: [],
      searchForm: {
        DATE_RANGE: [date(new Date(), '%F'), date(new Date(), '%F')],
      },
      项目点列表: [],
      供应商列表: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 15,
    };
  },
  created() {
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.DS_ORDER_INQUIRY_DATA_CONDITION.CONDITION) {
      this.searchForm = this.DS_ORDER_INQUIRY_DATA_CONDITION.CONDITION;
      this.currentPage = this.DS_ORDER_INQUIRY_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.拉取项目点信息();
    this.拉取供应商信息();
    this.拉取列表数据();
  },
  computed: {
    DS_ORDER_INQUIRY_DATA_CONDITION() {
      return this.$store.state.DS_ORDER_INQUIRY_DATA_CONDITION;
    },
  },
  methods: {
    点击订单编号({
      ID, TC_NAME, SEND_DAY, PROJECT_NAME, DK_NAME, TOTAL_GYS_FEE,
    }) {
      sessionStorage.setItem('DSOrderDetailTitle', JSON.stringify({
        ORDER_ID: ID,
        SEND_DATE: SEND_DAY,
        CUSTOMER_NAME: TC_NAME,
        PROJECT_NAME,
        DK_NAME,
        TOTAL_FEE: TOTAL_GYS_FEE,
      }));
      this.$router.push({ name: 'DSOrdeInquiryDetail', params: { id: ID } });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.拉取列表数据();
    },
    筛选() {
      this.currentPage = 1;
      this.拉取列表数据();
    },
    拉取列表数据() {
      if (判断日期范围是否超过限制(...this.searchForm.DATE_RANGE, 365)) {
        this.$message.show({ text: '日期范围请不要超过一年', type: 'warning' });
        return false;
      }
      const params = {
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
        START_DAY: this.searchForm.DATE_RANGE[0],
        END_DAY: this.searchForm.DATE_RANGE[1],
        NEED_COUNT: 1,
      };
      if (this.searchForm.PRODUCT_CODE) params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      if (this.searchForm.PRODUCT_NAME) params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      if (this.searchForm.PROJECT_ID) params.PROJECT_ID = this.searchForm.PROJECT_ID;
      if (this.searchForm.SUPPLIER_ID) params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      订单查询(params).then((result) => {
        if (result.length > 0) {
          this.列表数据 = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_DS_ORDER_INQUIRY_DATA_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.列表数据 = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    拉取项目点信息() {
      haveDSXMDFun().then((result) => {
        this.项目点列表 = result.length > 0 ? result[0].project : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    拉取供应商信息() {
      haveSupplierFun().then((result) => {
        this.供应商列表 = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DSOrder/DSOrdeInquiry.vue